export enum ComponentDataState {
  Loading,
  HasData,
  NoData,
}
